import ScalarTextInputCopy_vue_vue_type_script_setup_true_lang_default from "./ScalarTextInputCopy.vue.script.js";
//#region src/components/ScalarTextInput/ScalarTextInputCopy.vue
var ScalarTextInputCopy_default = ScalarTextInputCopy_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarTextInputCopy_default as default };

//# sourceMappingURL=ScalarTextInputCopy.vue.js.map